import React from "react";
import { FaInstagram } from "react-icons/fa"; 
import Reviews from "../components/Reviews";
import Millie1 from "../assets/images/Millie1.JPG";
import MillieWave from "../components/MillieWave";

export default function MainHome() {
  return (
    <div className="pt-10 px-6 max-w-6xl mx-auto">

       {/* Millie Animation */}
      <div className="relative mb-6">
          {/* Header */}
          <h1 className="text-4xl font-bold text-yellow-700 text-center">
            Welcome to Millie’s World
          </h1>

          {/* Millie mascot */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 hidden md:block">
            <MillieWave />
          </div>
      </div>


      {/* Description */}
      <p className="text-lg text-yellow-800 mb-8 max-w-xl">
        Get to know Millie Mesiner and discover her happiest moments — full of family and friends, joy,
        and smiles. 💛
      </p>

      {/* Image Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="aspect-square">
          <img
            src="images/Activities/Act12.jpeg"
            alt="Millie"
            loading="lazy"
            className="w-full h-full object-cover rounded-xl shadow-lg"
          />
        </div>

        <div className="aspect-square">
          <img
            src={Millie1}
            alt="Millie"
            loading="lazy"
            className="w-full h-full object-cover rounded-xl shadow-lg"
          />
        </div>

        <div className="aspect-square">
          <img
            src="images/Travel/Travel11.JPG"
            alt="Millie"
            loading="lazy"
            className="w-full h-full object-cover rounded-xl shadow-lg"
          />
        </div>
      </div>

            {/* Video Section */}
      <section className="mt-16 bg-yellow-50 rounded-3xl p-8">
        <h2 className="text-3xl font-bold text-yellow-700 mb-4">
          Uplifting Athletes | Millie joins the Philadelphia Union ⚽️
        </h2>

        <p className="text-yellow-800 mb-6 max-w-2xl mx-auto">
          Welcome to the team Millie! Through Uplifting Athletes, Millie signed a one-day contract and got to experience a day with the team.
        </p>

        <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-xl">
          <iframe
            src="https://www.youtube.com/embed/QXfCJrzCj0U"
            title="Millie's Story"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
          ></iframe>
        </div>
      </section>


      {/* Instagram Link */}
      <div className="mt-8">
        <a
          href="https://www.instagram.com/milliemeisne?igsh=eTRjenRuYzY4cjU%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-4 py-2 bg-yellow-500 text-white rounded-lg shadow hover:bg-yellow-600 transition duration-200"
        >
          <FaInstagram className="mr-2" />
          Follow Millie on Instagram
        </a>
      </div>
      <Reviews />

    </div>
  );
}
